export default __webpack_public_path__ + "static/media/missions.d6235f3b.png";